module.exports = __webpack_public_path__ + "static/1-13b96311cdeec6ffc5ee941909f357dc.gif";